<template>
  <div class="welcome-default-wrapper">
    <Card style="width:320px" class="card">
      <div style="text-align:center">
        <img src="../assets/logo.png">
        <h3>即将跳转到登录页面...</h3>
      </div>
    </Card>
  </div>
</template>

<script>
export default {
  name: 'wewlcome-default',
  data () {
    return {
      ready: false
    }
  },
  watch: {
    ready: function (newVal) {
      if (newVal) {
        if (window.localStorage.getItem('token') || this.$common.getCookie('token')) {
          this.initMyData().then(() => {
            this.$router.replace('/dashboard')
          }).catch(() => {
            this.$router.replace('/login')
          })
        } else {
          this.$router.replace('/login')
        }
      }
    }
  },
  mounted () {
    this.ready = true
  },
  methods: {
    getConfigs () {
      return new Promise((resolve, reject) => {
        this.$Api.KVS.getKVS('SITE_CONFIGS').then((res) => {
          console.log(res, JSON.parse(res))
          let configsStr = res
          let configs = JSON.parse(configsStr)
          if (configs) {
            this.$store.dispatch('setConfigs', configs)
            document.title = configs.TITLE
            window.localStorage.setItem('current_theme', configs.THEME)
            if (configs.MAINTAINING === true) {
              if (window.location.href.indexOf('maintaining.html') < 0) {
                window.location.href = '/maintaining.html'
              }
            }
            resolve(configs)
          }
        }).catch(err => {
          this.$Message.error('初始化失败!' + err.message)
          reject(err)
        })
      })
    },
    initMyData () {
      return new Promise((resolve, reject) => {
        this.$Api.Auth(this).getMyDetail().then((data) => {
          this.$store.dispatch('setUserInfo', data)
          window.localStorage.setItem('userInfo', JSON.stringify(data))
          resolve()
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.welcome-default-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .card {
    padding: 30px 0;
  }
}
</style>